export const DEFAULT_DEPLOY_TTL = 1800000;
